export const WEAPON = {
  id: 'fists',
  label: 'Fists',
  class: 'melee',
  caliber: null,
  /** Free starter weapon — never enters the armory's purchase flow. */
  price: 0,
  rpm: 170,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 170,
  burstDelay: 0.1,
  magSize: 0,
  reserve: 0,
  muzzleVelocity: 0,
  // Card 142f6041 "Fists Damage Increase": 30 -> 60. Still under the server's
  // MAX_DAMAGE_BODY cap (100) and well below the knife (110), so fists stay the
  // starter melee rather than a knife substitute.
  damage: 60,
  meleeRange: 1.1,
  penetration: 0,
  dropoff: 0,
  maxRange: 0,
  dragK: 0,
  tracerEvery: 999,
  spreadHip: 0,
  spreadAds: 0,
  spreadPerShot: 0,
  spreadMax: 0,
  spreadDecay: 1,
  recoil: {
    pitch: 0.007,
    yaw: 0.003,
    kickBack: 0.014,
    kickUp: 0.008,
    roll: 0.03,
    punch: 0.3,
    freq: 10,
    damping: 0.4,
    patternLength: 1,
    patternSeed: 0x2,
    climbShape: [1.0],
    drift: 0,
  },
  adsTime: 0.1,
  adsFov: 1.0,
  viewFov: 1.0,
  reloadTac: 0.01,
  reloadEmpty: 0.01,
  inspectTime: 1.8,
  drawTime: 0.22,
  holsterTime: 0.18,
  hipPos: [0.07, -0.12, -0.18],
  hipRot: [-0.1, 0.1, -0.05],
  adsCant: [0, 0, 0],
  eyeRelief: 0.18,
  sprintPos: [0.06, -0.18, -0.16],
  sprintRot: [-0.3, 0.4, 0.1],
  lowReadyPos: [0.07, -0.2, -0.18],
  lowReadyRot: [-0.35, 0.1, -0.05],
  swayScale: 1.35,
  bobScale: 1.25,
  magLen: 0.1,
};

export const loadModel = () => import('../models/fists.js').then((m) => m.buildFists);
